/**
 * @example
 * pluralize(2, 'categor', 'ies', 'y');
 * // Returns '2 categories'
 */
export default function pluralize(number: number, word: string, pluralSuffix = 's', singularSuffix = ''): string {
  return `${number} ${word}${number !== 1 ? pluralSuffix : singularSuffix}`;
}
